module.exports = __webpack_public_path__ + "img/tree.58271fc8.png";